import React from "react";
import Lottie from "lottie-react";
import TransactionLoaderGif from "../Images/loader.json";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  zIndex: 9999,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

const TransactionLoader = ({ children, isActive, text }) => {
  return (
    <>
      {isActive && (
        <div style={overlayStyle}>
          <Lottie
            style={{ height: "200px", marginBottom: "1rem" }}
            animationData={TransactionLoaderGif}
          />
          {text && <div style={{ fontSize: "1.2rem", color: "#555" }}>{text}</div>}
        </div>
      )}
      {children}
    </>
  );
};

export default TransactionLoader;
